module.exports = __webpack_public_path__ + "img/chest-9.fb68a37c.png";